import { render } from "./GoogleMapsWithMarkers.vue?vue&type=template&id=45fde97b"
import script from "./GoogleMapsWithMarkers.vue?vue&type=script&lang=js"
export * from "./GoogleMapsWithMarkers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__